import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [session, setSession] = useState(null);

  const load = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setSession(data);
    } catch {
      try {
        await api.post("/auth/refresh");
        const { data } = await api.get("/auth/me");
        setSession(data);
      } catch {
        setSession(false);
      }
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  useEffect(() => {
    const h = () => setSession(false);
    window.addEventListener("auth:expired", h);
    return () => window.removeEventListener("auth:expired", h);
  }, []);

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } finally {
      setSession(false);
    }
  };

  const value = {
    session, setSession, reload: load, logout,
    user: session?.user, business: session?.business,
    tz: session?.business?.timezone || "UTC",
    isManager: ["owner", "admin"].includes(session?.user?.role),
  };
  return <AuthCtx.Provider value={value}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);
